
import OrderListStore from '../module_biz/list/orderList/store/OrderListStore';
import SaleDeliveryListStore from '../module_biz/list/saledeliveryList/store/SaleDeliveryListStore';
import ListStore from '../module_biz/list/list/store/ListStore';
export default {
    OrderListStore: new OrderListStore(),
    SaleDeliveryListStore:new SaleDeliveryListStore(),
    ListStore:new ListStore()

};
